exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reports{width:100%;overflow:hidden}.reports .rowWrapperSearchReports{display:flex;justify-content:space-between;align-items:center}\n", ""]);

